module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "md-icon": "home",
      "md-label": "Dashboard"
    }
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Clients")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                      By No. of Containers Executed \n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsRefuel,
      "series": _vm.seriesRefuel
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Place of Receipt")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                      By No. of Containers  (Export)\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsExDesti,
      "series": _vm.seriesExDesti
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Shipping Line")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                      By No. of Containers Shipped \n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsShip,
      "series": _vm.seriesShip
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Exported Commodities")]), _vm._v(" "), _vm._l((_vm.topcommodity), function(item1, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex mt-3 py-2 border-bottom"
    }, [_c('div', [_c('p', {
      staticClass: "mb-n1 font-weight-semibold"
    }, [_vm._v("\n                          " + _vm._s(item1.itemDescription) + "\n                        ")])]), _vm._v(" "), _c('small', {
      staticClass: "text-muted ml-auto"
    }, [_vm._v("Exported  " + _vm._s(item1.commodityCount) + " Times ")])])
  })], 2)])])])]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "md-icon": "content_paste",
      "md-label": "CC Export Reports"
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('b-button', {
    class: _vm.visibleEx ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visibleEx ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visibleEx = !_vm.visibleEx
      }
    }
  }, [_vm._v("Filters")]), _vm._v(" "), (_vm.exportData.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('CC_Export')
      }
    }
  }, [_vm._v("Export as Excel")]) : _vm._e()], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visibleEx),
      callback: function($$v) {
        _vm.visibleEx = $$v
      },
      expression: "visibleEx"
    }
  }, [_c('b-card', {
    staticClass: "gutr"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.viewAssignment('0', '1', '1');
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRowsExport) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableMain table-responsive mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.exportData,
      "fields": _vm.fieldsExport,
      "per-page": _vm.perPageExport,
      "sort-by": _vm.sortByExport,
      "sort-desc": _vm.sortDescExport,
      "sort-direction": _vm.sortDirectionExport
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortByExport = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDescExport = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "seenExec",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPageExport - 1) * _vm.perPageExport))])]
      }
    }, {
      key: "ccImportSeries",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.ccImportSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Date : " + _vm._s(_vm._f("moment")(row1.item.dateAssignment)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.EmpLoc))])]
      }
    }, {
      key: "Exporter",
      fn: function(row11) {
        return [_c('b', [_vm._v("Exporter : " + _vm._s(row11.item.Exporter))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Importer : " + _vm._s(row11.item.Importer))])]
      }
    }, {
      key: "placeRecp",
      fn: function(row10) {
        return [_c('span', [_vm._v("Place of Receipt :- " + _vm._s(row10.item.placeRecp))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Load Port :- " + _vm._s(row10.item.LoadPort))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Port Of Discharge :- " + _vm._s(row10.item.placeDis))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Final Place of Delivery :- " + _vm._s(row10.item.finalPlace))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "containerDetails",
      fn: function(row5) {
        return [(row5.item.containerDetails != null) ? _c('div', _vm._l((row5.item.containerDetails.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == '' ? '-------' : item1))])], 1)])
        })) : _vm._e()]
      }
    }, {
      key: "containerTypeData",
      fn: function(row15) {
        return [(row15.item.containerTypeData != null) ? _c('div', _vm._l((row15.item.containerTypeData.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2))])], 1)])
        })) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPageExport,
      "total-rows": _vm.totalRowsExport
    },
    on: {
      "change": function($event) {
        _vm.onPageChangeExport($event)
      }
    },
    model: {
      value: (_vm.currentPageExport),
      callback: function($$v) {
        _vm.currentPageExport = $$v
      },
      expression: "currentPageExport"
    }
  })], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4680601e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/ccExportReports.vue
// module id = 2578
// module chunks = 0